export enum FieldStatusEnum {
  AutoTranslated = 'AutoTranslated',
  LastSaved = 'LastSaved',
  Edited = 'Edited',
}
